// Version : 0.0.1
// Author : AGALYA

import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** ***************** GET ACTIVE MEMBER START *********************** */
export const ActiveMemberListGet = (listData: any) => {
	const data = {
		GetActiveMemberReportToken: listData,
	};
	const url = `${API_URL}getAllActiveMembers`;
	return makeApiCall(url, data);
};
/** ***************** GET ACTIVE MEMBER START *********************** */
